import React from "react";
import Icon from "../Icon";
import { endSlash } from "../../util/helperFunctions";

const ButtonArrowRight = ({ className, path, text }) => {
  return (
    <div className="button--arrow-right__wrapper mt1 mt2-l">
      <a
        href={endSlash(path)}
        target="_blank"
        download={`${text}.pdf`}
        className={`${className} button--arrow-right db ttu h-5 tl db flex items-center justify-between w-100 bg-blue white hover-bg-stone bg-ease-out pl2 mb1 mb2-l`}
      >
        {text}
        <div className="button--arrow-right__arrow bg-dark h-100">
          <Icon path="arrow-right" className="flex items-center h-100" />
        </div>
      </a>
    </div>
  );
};

export default ButtonArrowRight;



// WEBPACK FOOTER //
// ./src/components/Buttons/ButtonArrowRight.js